/**
 * @generated SignedSource<<e08ea7a2125f85e9825d1d1f9b2e1a30>>
 * @relayHash a2cb913fc3c86df01d3e338fd395a936
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c887506aa51fd06a04e1b86d8650b40da5f2a17132f183e7ff6bd7479fd63fe

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiJiraBoardFetchPullRequestDetailsForIssueNewQuery } from './uiJiraBoardFetchPullRequestDetailsForIssueNewQuery.graphql';

const node: PreloadableConcreteRequest<uiJiraBoardFetchPullRequestDetailsForIssueNewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9c887506aa51fd06a04e1b86d8650b40da5f2a17132f183e7ff6bd7479fd63fe",
    "metadata": {},
    "name": "uiJiraBoardFetchPullRequestDetailsForIssueNewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
